@if (visible()) {
<div class="main-container">
  <div class="container">
    <img
      class="loader-icon"
      [src]="isDarkTheme() ? 'assets/images/logos/x-light.png' : 'assets/images/logos/x-dark.png'"
      alt="Loading..."
    />
    <div class="inner">
      <div class="line"></div>
      <div class="line line--two"></div>
      <div class="oval"></div>
      <div class="oval oval--two"></div>
    </div>
    <div class="shadow"></div>
  </div>
  @if (text()) {
  <p
    class="loading-text"
    [ngClass]="{ 'text-white': isDarkTheme() }"
  >
    {{ text() }}
  </p>
  }
</div>
}
